import { queryOptions } from "@tanstack/react-query";
import { api } from "../../lib/api/client";
import type { ContingentRoomRef } from "@seagames/contracts";

/**
 * The one NOC read S4's `lib/api/accommodation.ts` does not have.
 *
 * `GET /accommodation/contingents/:org/rooms?games_id=` → `{ items: ContingentRoomRef[] }` (S3): the DISTINCT rooms the organisation's own open
 * assignments hold (room, building), one `SELECT DISTINCT` over
 * `uq_room_assignments_open_card` ⋈ the org's APPROVED cards in scope.
 * It names rooms only — never who else stays there (NOC privacy) — and is
 * what "Report a room problem" may pick from (PLAN A13).
 *
 * Under S4's `["accommodation", …]` prefix, so an assignment write refreshes it.
 */
export const reportableRoomsOptions = (orgId: string, gamesId: string, enabled = true) =>
	queryOptions({
		queryKey: ["accommodation", "contingent", gamesId, orgId, "rooms"] as const,
		queryFn: ({ signal }) => api.get<{ items: ContingentRoomRef[] }>(`/accommodation/contingents/${orgId}/rooms`, { query: { games_id: gamesId }, signal }),
		staleTime: 60_000,
		enabled,
	});
